import React from "react";
import { Theme } from "../../theme";

export const CheckIcon = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.999"
            height="10"
            viewBox="0 0 12.999 10"
            fill={fill || Theme.colors.blue}
            {...props}
        >
            <path
                d="M612.486,1566.989h0a1.1,1.1,0,0,1-.778-.326l-3.093-3.162a1.1,1.1,0,0,1,1.56-1.541l2.317,2.367,6.937-7.014a1.1,1.1,0,1,1,1.553,1.549l-7.717,7.8a1.093,1.093,0,0,1-.777.324"
                transform="translate(-608.299 -1556.989)"
            />
        </svg>
    );
};
